/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { getPublicSiteUrl } from "@cosmos/common-utils";

export const getApiPath = (): string => {
	return `${getPublicSiteUrl()}${process.env.NEXT_PUBLIC_COSMOS_API_PATH || "/api"}`;
};
